/* eslint-disable no-console -- Logger for browser wrap console log call */
import type { Logger, BaseLogContext, SentryAdapter } from './types';

export type { BaseLogContext };

interface CreateBrowserLoggerOptions {
  service: string;
  sentry?: SentryAdapter;
}

export function createBrowserLogger<T extends BaseLogContext = BaseLogContext>(
  options: CreateBrowserLoggerOptions,
): Logger<T> {
  const prefix = `[${options.service}]`;

  function captureIfError(context?: T | Error): void {
    if (!options.sentry) return;
    if (context instanceof Error) {
      options.sentry.captureException(context);
      return;
    }
    if (context?.err instanceof Error) {
      const { err, tags, ...extra } = context as Record<string, unknown>;
      options.sentry.captureException(err, {
        extra: Object.keys(extra).length
          ? (extra as Record<string, unknown>)
          : undefined,
        tags: tags as Record<string, string> | undefined,
      });
    }
  }

  return {
    debug: (msg, context) => console.debug(prefix, msg, context ?? ''),
    info: (msg, context) => console.info(prefix, msg, context ?? ''),
    warn: (msg, context) => console.warn(prefix, msg, context ?? ''),
    error: (msg, context) => {
      console.error(prefix, msg, context ?? '');
      captureIfError(context);
    },
  };
}
